import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFieldDecimalPlacesConfig } from 'hooks';
import { Grid } from '@mui/material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';
import { Done, SystemUpdateAlt } from '@mui/icons-material';
import { emptyString } from 'utils/constants';
import * as constants from 'features/assetHierarchy/constants';
import defaultImage from 'assets/img/Car2.png';

const AssetHierarchyDetailsComponent = ({ hierarchy, image, actions }) => {
  const { t } = useTranslation();
  const { cvsChPrice } = useFieldDecimalPlacesConfig();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={7}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <DateTime
              name='validFrom'
              value={hierarchy.validFrom}
              timeFormat={false}
              label={t('General.ValidFrom')}
              onChange={() => {}}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DateTime
              name='validTo'
              value={hierarchy.validTo}
              timeFormat={false}
              label={t('General.ValidTo')}
              onChange={() => {}}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              fullWidth
              id='image-url-address'
              label={t('AssetHierarchy.List.Actions.ViewDetails.ImageAddress')}
              value={image.url || emptyString}
              onChange={event => actions.onAssetImageUrlChange(event)}
              error={image.error}
              helperText={image.error}
              endAdornment={
                <>
                  <IconButton
                    onClick={actions.saveAssetHierarchyImage.onEffect}
                    size='tiny'
                    disabled={actions.saveAssetHierarchyImage.disabled}
                    color='transparent'
                    tooltip={t('Save')}
                    sx={image.saved ? { color: '#33cc33' } : {}}
                  >
                    <Done />
                  </IconButton>
                  {hierarchy.source === constants.EUROTAX && (
                    <IconButton
                      onClick={actions.acquireAssetHierarchyImage.onEffect}
                      size='tiny'
                      disabled={actions.acquireAssetHierarchyImage.disabled}
                      color='transparent'
                      tooltip={t('AssetHierarchy.List.Actions.ViewDetails.RetrieveImage')}
                    >
                      <SystemUpdateAlt />
                    </IconButton>
                  )}
                </>
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id='asset-hierarchy-unique-identifier'
              value={hierarchy.uniqueIdentifier || emptyString}
              label={t('AssetHierarchy.List.Actions.ViewDetails.UniqueIdentifier')}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              isNumeric
              id='asset-list-price'
              decimalScale={cvsChPrice}
              value={hierarchy.listPrice || emptyString}
              label={t('AssetHierarchy.List.Actions.ViewDetails.ListPrice', { currency: hierarchy.currencyCode })}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id='item-code'
              value={hierarchy.itemCode || emptyString}
              label={t('AssetHierarchy.List.Actions.ViewDetails.ItemCode')}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id='item-name'
              value={hierarchy.itemName || emptyString}
              label={t('AssetHierarchy.List.Actions.ViewDetails.ItemName')}
              disabled={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={1}></Grid>
      <Grid item xs={12} sm={4}>
        <img src={image.url || defaultImage} style={{ maxWidth: '100%' }} alt='...' />
      </Grid>
    </Grid>
  );
};

AssetHierarchyDetailsComponent.propTypes = {
  hierarchy: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default AssetHierarchyDetailsComponent;
